// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.password-field[data-v-5e25cf43] input{-webkit-text-security:disc}
`, "",{"version":3,"sources":["webpack://./src/common/components/TPasswordInput.vue"],"names":[],"mappings":"AAIA,uCACE,0BAA2B","sourcesContent":["\n// Password field is using text input type\n// but we style it as password field to prevent\n// browser to offer password remembering\n.password-field :deep(input) {\n  -webkit-text-security: disc;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
